import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TcsLoadUntilModule } from '../tcs-load-until/tcs-load-until.module';
import { TcsOktaCallbackComponent } from './components/tcs-okta-callback/tcs-okta-callback.component';

@NgModule({
  declarations: [TcsOktaCallbackComponent],
  imports: [CommonModule, TcsLoadUntilModule],
})
export class TcsIdentityModule {}
